<script>
import { mapActions, mapGetters } from 'vuex'
import baseMixin from '@/mixins/baseMixin'
import FilePreviewContainer from '../general/file-preview-container.vue'

export default {
  name: 'InvoiceFilePreview',
  components: {
    FilePreviewContainer,
  },
  mixins: [baseMixin],
  props: {
    invoice: {
      type: Object,
      required: true,
    },
    show: {
      type: Boolean,
      required: true,
    },
  },
  data: () => {
    return {
      fileData: '',
      fileDefinition: {},
    }
  },
  computed: {
    ...mapGetters({
      isDownloadingFile: 'invoices/isDownloadingFile',
    }),
  },
  watch: {
    show(n, o) {
      if (n) {
        this.downloadFile()
      } else {
        this.fileData = ''
        this.fileDefinition = {}
      }
    },
  },
  methods: {
    ...mapActions({
      downloadInvoiceFile: 'invoices/downloadInvoiceFile',
    }),
    async downloadFile() {
      const result = await this.downloadInvoiceFile(this.invoice.invoiceID)

      if (!result.isSuccess) return

      this.fileData = result.data
      this.fileDefinition = {
        fileName: 'invoice.pdf',
      }
    },
  },
}
</script>

<template>
  <section>
    <v-dialog
      v-model="show"
      fullscreen
      hide-overlay
      persistent
      no-click-animation
      transition="dialog-bottom-transition"
      @input="$emit('update:show')"
    >
      <v-card>
        <v-card-title
          >{{ `${$t('finance.invoiceText')} #${invoice.invoiceNumber}` }}
          <v-btn class="ml-auto" icon @click="$emit('update:show', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <FilePreviewContainer
            :loading="isDownloadingFile"
            :file-data="fileData"
            :file-definition="fileDefinition"
            :empty-state-title="$t('finance.invoiceFileNotAvailableText')"
            class="mt-4"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>
